export const environment = {
  production: false,
  apiUrl: 'https://api.dev.core.pos.vlife.id/api/v2/',
  masterPolicyApiUrl: 'https://api.dev.core.pos.vlife.id/api/v2/',
};
